import React from 'react';
import { Outlet } from 'react-router-dom';

const Profile = () => {
	return <Outlet />;
};

export default Profile;
